<template>
  <div>
    <PageAllow controller="Suppliers" action="supplierScoreView" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="datetimeRage"
                type="date"
                :label="$t('StockPosition.Fields.create')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                v-if="$permission.permissionAllow('Suppliers', 'supplierScoreViewExport')"
                small
                color="print"
                dark
                @click="exports()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("supplierScoreDetail.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <!-- 供应商分区 -->
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="keyword = $event"
                    :label="$t('Supplier.Keyword')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="settings && settings.supplier_expire_show_flg"
                >
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("supplierScoreDetail.orderToPurchase.title") }}
                  </div>
                  <v-radio-group row v-model="options.order_to_purchase_flg">
<!--                    <v-radio-->
<!--                      :label="$t('supplierScoreDetail.orderToPurchase.all')"-->
<!--                      key="all"-->
<!--                      value="all"-->
<!--                    />-->
                    <v-radio
                      :label="$t('supplierScoreDetail.orderToPurchase.all')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('supplierScoreDetail.orderToPurchase.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="suppliers"
            :options.sync="options"
            :loading="loading"
            multi-sort
            disable-pagination
            hide-default-footer
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            fixed-header
          >
            <template v-slot:item.level="{ item }">
              <v-chip
                small
                label
                :color="item.level | supplierLevelColor"
                :text-color="item.level | supplierLevelTextColor"
              >
                {{ item.level | supplierLevelText}}
              </v-chip>
            </template>
            <template v-slot:item.satisfaction_rate="{ item }">
              {{ item.satisfaction_rate ? (item.satisfaction_rate * 100).toFixed(2) : 0 }}{{ $t("Global.rate") }} /
              {{ item.satisfaction_score ? item.satisfaction_score : 0 }}{{ $t("Global.score") }}
            </template>
            <template v-slot:item.timeliness_rate="{ item }">
              {{ item.timeliness_rate ? (item.timeliness_rate * 100).toFixed(2) : 0 }}{{ $t("Global.rate") }} /
              {{ item.timeliness_score ? item.timeliness_score : 0 }}{{ $t("Global.score") }}
            </template>
            <template v-slot:item.qualification_rate="{ item }">
              {{ item.qualification_rate ? (item.qualification_rate * 100).toFixed(2) : 0 }}{{ $t("Global.rate") }} /
              {{ item.qualification_score ? item.qualification_score : 0 }}{{ $t("Global.score") }}
            </template>
            <template v-slot:item.price_fluctuation_num="{ item }">
              {{ item.price_fluctuation_num ? item.price_fluctuation_num : 0 }}{{ $t("Global.times") }} /
              {{ item.fluctuation_score ? item.fluctuation_score : 0 }}{{ $t("Global.score") }}
            </template>
            <template v-slot:item.after_sale_score="{ item }">
              {{ item.after_sale_score }}{{ $t("Global.score") }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";

import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import Suppliers from "@/api/suppliers";

const defaultOptions = {
  keyword: "",
  finish_date_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10),
  finish_date_to: new Date().toISOString().substr(0, 10),
  order_to_purchase_flg: 0,
};

export default {
  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10),
      new Date().toISOString().substr(0, 10),
    ],
    suppliers: [],
    options: JSON.parse(
      sessionStorage.getItem("supplier-score-detail-options")
        ? sessionStorage.getItem("supplier-score-detail-options")
        : JSON.stringify(defaultOptions)
    ),
    keyword: "",
  }),
  components: {
    Breadcrumbs,
    PageAllow,
    SearcherKeyword,
    SearcherDatetimeRangeWithRadio,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.supplier"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.supplierScore"),
        disabled: false,
        href: "/supplier-score",
      },
      {
        text: i18n.t("Nav.supplierScoreDetail"),
        disabled: true,
        href: "/supplier-score/detail",
      },

    ],
    headers: () => [
      {
        text: i18n.t("supplierScoreDetail.Fields.supplier_code"),
        align: "start",
        sortable: false,
        value: "supplier_code",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.supplier_name"),
        align: "start",
        sortable: false,
        value: "supplier_name",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.level"),
        align: "center",
        sortable: false,
        class: "text-no-wrap",
        value: "level",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.score"),
        align: "start",
        sortable: false,
        value: "score",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.satisfaction_rate"),
        align: "start",
        sortable: false,
        value: "satisfaction_rate",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.timeliness_rate"),
        align: "start",
        sortable: false,
        value: "timeliness_rate",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.qualification_rate"),
        align: "start",
        sortable: false,
        value: "qualification_rate",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.price_fluctuation_num"),
        align: "start",
        sortable: false,
        value: "price_fluctuation_num",
      },
      {
        text: i18n.t("supplierScoreDetail.Fields.after_sale_score"),
        align: "start",
        sortable: false,
        value: "after_sale_score"
      }
    ],
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("supplier-score-detail", [])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (typeof this.options.finish_date_from != "undefined" && typeof this.options.finish_date_to != "undefined") {
              this.datetimeRage = [
                this.options.finish_date_from,
                this.options.finish_date_to,
              ];
            }
          } else this.resetSearch();
        }.bind(this)
      );
    // 带入上个页面的时间范围
    this.$commonUtils
      .loadOptions("supplier-score", [])
      .then(
        function (data) {
          if (data.options) {
            if (typeof data.options.finish_date_from != "undefined" && typeof data.options.finish_date_to != "undefined") {
              this.datetimeRage = [
                data.options.finish_date_from,
                data.options.finish_date_to,
              ];
            }
          } else this.resetSearch();
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getSupplierFromAPI() {
      Suppliers.getSupplierScoreView(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.suppliers = response.data.suppliers;
          }
        }.bind(this)
      );
    },
    exports() {
      Suppliers.supplierScoreViewExport(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getSupplierFromAPI();
        sessionStorage.setItem(
          "supplier-score-detail-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.finish_date_from = new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10);
        } else {
          this.options.finish_date_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.finish_date_to = new Date().toISOString().substr(0, 10);
        } else {
          this.options.finish_date_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>

<style>
</style>